import React, { Component } from "react";
import { Button, FormGroup, FormControl, ControlLabel } from "react-bootstrap";
import logologin from '../../Comman/images/logo-new.png'

import logobackground from '../../Comman/images/loginbg.png'
import { Redirect, withRouter } from 'react-router-dom'
import '../../Comman/assets/css/user/style.css'
import SimpleReactValidator from 'simple-react-validator';
import Modal from 'react-responsive-modal';
import { baseUrl } from '../../Comman/apiEndPoints';
import { Link } from 'react-router-dom';
import '../../Comman/assets/css/forgotpass.css';
class ForgotPasswordComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      method:'',
      EmailID:'',
      Phone:'',
      Email: '',
      openModal: false,
      redirect: false,
      adminRadio: false,
      userRadio: true,
     // redirectAdmin: false,
      redirectUser: false
    };
    this.userChange = this.userChange.bind(this)
    this.validator = new SimpleReactValidator();
    this.handleInput = this.handleInput.bind(this);
  }
  componentWillReceiveProps(nextProps){
       
    if(nextProps.forgotPassword!=this.props.forgotPassword){
        if(nextProps.forgotPassword.statusCode==200){
           this.setState({
             Email:''
           })
           this.validator.hideMessages();
        }
         /* if(nextProps.forgotPassword.verifyStatusCode==200){
        console.log('hi')
        } */
       
        
    }
}
    componentDidUpdate(nextProps) {
        
      if(nextProps.forgotPassword!=this.props.forgotPassword){
       
         if(nextProps.forgotPassword.requestForgotPasswordDetail !=null && nextProps.forgotPassword.requestForgotPasswordDetail !=undefined && nextProps.forgotPassword.requestForgotPasswordDetail !={} && nextProps.forgotPassword.requestForgotPasswordDetail!=this.props.forgotPassword.requestForgotPasswordDetail ){
        this.openModal()
        }
         if(nextProps.forgotPassword.verifyStatusCode==200 && nextProps.forgotPassword.verifyStatusCode !=this.props.forgotPassword.verifyStatusCode){
       // this.closeModal()
        }
        
    }
    }
  setRedirect = () => {
    this.setState({
      redirect: true
    })
  }
openModal = () => {
        this.setState({ openModal: true })
    }
    closeModal = () => {
        this.setState({ openModal: false })
       
        this.setState({Email:'',method:''})
    }
  // renderRedirect = () => {
  //   if (this.state.redirect) {
  //     return <Redirect to='/registration' />
  //   }
  // }
  // renderRedirectUser = () => {
  //   if (this.state.redirectUser) {
  //     return <Redirect to='/login' />
  //   }
  // }
  // renderRedirectAdmin = () => {
  //   if (this.state.redirectAdmin) {
  //     return <Redirect to='/adminLogin' />
  //   }
  // }
  userChange(e) {
    this.props.history.push('/login')
    this.setState({ redirectUser: true });
  }



  handleChange = event => {
    this.setState({
      [event.target.id]: event.target.value
    });
  }
 handleInput = (e) => {

  if(e==='phone')
  {
    this.setState({method:e})
  }
  if(e==='email')
  {
    this.setState({method:e})
  }
       
    }
  ResetPassword = event => {
    event.preventDefault();
    if (this.validator.allValid()) {
      this.props.ResetPassword(this.state.Email);
    }
    else{
      this.validator.showMessages();
      
      this.forceUpdate();
    }
  }

  validateForm() {
    if (this.state.Email.length > 0)
      return true;
    else
      return false;
  }
add=()=>{
  let data
  if(this.state.method=='phone')
  {
    data={
       "Phone":this.props.forgotPassword.requestForgotPasswordDetail.Phone,
    "UserId": this.props.forgotPassword.requestForgotPasswordDetail.UserId,
    }
  }
   if(this.state.method=='email')
  {
    data={
       "EmailID":this.props.forgotPassword.requestForgotPasswordDetail.EmailId,
    "UserId": this.props.forgotPassword.requestForgotPasswordDetail.UserId,
    }
  }
 this.props.ResetPassword2(data);
}
  render() {
    const { t } = this.props;
    let backgroundImage,logoImageUrl,signingtext
   
       console.log('kj',this.props.forgotPassword)
       if(this.props.forgotPassword.brandList.length !=0)
       {
    backgroundImage=baseUrl+this.props.forgotPassword.brandList[0].BackGroundImage;
    logoImageUrl=baseUrl+this.props.forgotPassword.brandList[0].BannerImage;
    signingtext=this.props.forgotPassword.brandList[0].SigningText;
       } 
    const maskString = (str, startLen = 4, endLen = 4) => {
  if (!str || str.length <= startLen + endLen) {
    return str;
  }
  const start = str.slice(0, startLen);
  const end = str.slice(-endLen);
  const mask = '*'.repeat(str.length - startLen - endLen);
  return `${start}${mask}${end}`;
};
    return (
      <div>
        {
          this.props.forgotPassword.brandList.length !=0 ?<div className="loginbg" style={{backgroundImage:"url(" + backgroundImage + ")",backgroundRepeat:"no-repeat",backgroundPosition:"center center",backgroundSize:"cover",backgroundAttachment:"fixed"}}>
        <div className="login-main reset-form"  style={{background:"white",padding:"60px",position:"absolute",top:"50%",left:"50%",msTransform:"translateX(-50%) translateY(-50%)",WebkitTransform:"translate(-50%,-50%)",transform:"translate(-50%,-50%)",width:"50vh"}}>
          <div className="login-logo">
            <img src={logoImageUrl} />
          </div>
          <div className="k-form-field">
          
          
          <form onSubmit={this.ResetPassword} >
          <div className="login-fm ">




            <FormGroup controlId="Email">
              <p className="prblock">Did You forgot your password ?</p>
             <span className="prblock2">Enter Your Email to get code</span>
             {this.props.forgotPassword.statusCode == 200  ?
              <div className="alert alert-success" role="alert">
              {this.props.forgotPassword.errorMessage !== '' ? this.props.forgotPassword.errorMessage : ""}
             
               </div>:
              this.props.forgotPassword.errorMessage ?
                <div class="alert alert-danger">
                  {this.props.forgotPassword.errorMessage }
                </div>
                :
                ''
               
             
            }
             {/*  <label className="control-label"> 
              Enter Email                     
              </label> */}
         
              <FormControl
                className="login-main-form-control"
                autoFocus
                type="text"
                value={this.state.Email}
                onChange={this.handleChange}
                placeholder="Enter Email"
                name={'Email'}
              />
              {this.validator.message('Email', this.state.Email, 'required|email')}

            </FormGroup>
            
            </div>
              
      
            <div className="login-button">
              <Button type="submit"> Send Reset Code 
                {
                  this.props.forgotPassword.isLoading?
                  <i className="fa fa-spinner fa-spin pl-md-2" ></i>
                  :'' 
                }
              </Button>
              {/* {this.renderRedirect()} */}
              <p>
                <a href="#"><span className="yellow" style={{fontSize:'medium'}}><button className="signUp" onClick={this.userChange}>LOG IN</button></span></a>
               </p>
              {/* <br /><label className="label" id="errorMsg" style={{color: 'red'}}> </label> */}
            </div>
          </form>
          <p style={{color:"black !important",fontSize:"11px !important",marginTop:"0 !important"}} dangerouslySetInnerHTML={{ __html: signingtext }} ></p>
        </div>
      </div>
      </div>:''  

        }
    <Modal open={this.state.openModal} onClose={this.closeModal} center>
                    <div className="modal1 alarmsetmodal">
                        <div className="progressbar-heading grids-heading">
                            <h2>Select OTP Method</h2>
                        </div>
                        <div className="forms add-device setting-panel">
                            <div className="form-three widget-shadow">
                                <div className=" panel-body-inputin">
 <div className="otp-container" style={{display:'grid',justifyContent:'center',alignItems:'center',background:'gray',borderRadius:'20px',padding:'30px'}}>
      <div>
    <input id="option-one" name="radio" type="radio"
                value="email"
                checked={this.state.method === 'email'}
                onChange={(e) => this.handleInput(e.target.value)} />
    <label for="option-one">
        <span></span>
       {maskString(this.props.forgotPassword.requestForgotPasswordDetail.EmailId,5,4)}
    </label>
</div>
<div>
    <input id="option-two" name="radio"  type="radio"
                value="phone"
                checked={this.state.method === 'phone'}
                onChange={(e) => this.handleInput(e.target.value)}/>
    <label for="option-two">
        <span></span>
       {maskString(this.props.forgotPassword.requestForgotPasswordDetail.Phone,2,4)}
    </label>
</div>
       {/*  <div className="selection-form">
         
          <div className="method-selector" style={{display:"grid",fontSize:"large"}}>
            <label>
              <input style={{marginRight:"10px"}}
                type="radio"
                value="email"
                checked={this.state.method === 'email'}
                onChange={(e) => this.handleInput(e.target.value)}
              />
              {maskString(this.props.forgotPassword.requestForgotPasswordDetail.EmailId,3,2)}
            </label>
            <label>
              <input style={{marginRight:"10px"}}
                type="radio"
                value="phone"
                checked={this.state.method === 'phone'}
                onChange={(e) => this.handleInput(e.target.value)}
              />
                     {maskString(this.props.forgotPassword.requestForgotPasswordDetail.Phone,3,2)}
            </label>
          </div>
        </div> */}
    </div>
       <div className="form-group">
                                            <div className="col-sm-offset-5 col-sm-6">
                                                <p>
                                                  <Link to={`/resetpassword/${this.props.forgotPassword.requestForgotPasswordDetail.UserId}`}>
      <button
                                                        type="button"
                                                        className="btn btn-primary general-btn"
                                                        onClick={this.add}
                                                    >
                                                        Save
                                                    </button>
                                                    </Link>
                                                   
                                                </p>
                                            </div>
                                        </div>
                                        <br></br>
                                        <br></br>
                                        <br></br>
                                        {this.props.forgotPassword.verifyStatusCode == 200  ?
              <div className="alert alert-success" role="alert">
              {this.props.forgotPassword.verifyStatusCode !== '' ? this.props.forgotPassword.errorMessage : ""}
             
               </div>:
              this.props.forgotPassword.verifyStatusCode ?
                <div class="alert alert-danger">
                  {this.props.forgotPassword.verifyStatusCode }
                </div>
                :
                ''
               
             
            }
                                    </div>
                                    </div>
                                    </div>
                    </div>
                </Modal>
      
      </div>
    );
  }
}

export default withRouter(ForgotPasswordComponent)